import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SimplePlayer} from "../../entities/players/SimplePlayer";
import {APIService} from "../../services/APIService";
import {FormControl} from "@angular/forms";
import {BasicEventPlayer} from "../../entities/auth/BasicEventPlayer";
import {SelectionChange} from "@angular/cdk/collections";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";

@Component({
  selector: 'app-player-search',
  templateUrl: './player-search.component.html',
  styleUrls: ['./player-search.component.css']
})
export class PlayerSearchComponent implements OnInit {
  options: SimplePlayer[] = []
  lastChanged: number;
  control = new FormControl('');

  @Output()
  selectedPlayerEvent: EventEmitter<BasicEventPlayer>;

  @Input()
  player?: SimplePlayer;

  constructor(private apiService: APIService) {
    this.selectedPlayerEvent = new EventEmitter<BasicEventPlayer>();
    this.control.valueChanges.subscribe((a) => {
      const time = new Date().getTime();
      this.lastChanged = time;
      setTimeout(() => {
        if(time === this.lastChanged) {
          this.search(a!);
        }
      }, 1000);
    })
  }

  ngOnInit() {
    if(this.player) {
      this.control.setValue(this.player.username)
    }
  }

  select(uuid: string) {
    this.apiService.getPlayer(uuid).then((a) => {
      this.control.setValue(a.username)
      this.selectedPlayerEvent.emit(a);
    })
  }

  change(event: MatAutocompleteSelectedEvent) {
    this.select(event.option.value)
  }

  search(text: string) {
    this.apiService.searchPlayers(text).then((a) => {
      if(a === undefined)
        return;
      const list = Array.isArray(a.players) ? a.players : [];
      const byUuid = new Map<string, SimplePlayer>();
      for (const it of list) {
        if (!it) continue;
        const uuid = String((it as any).uuid ?? '').trim();
        const username = String((it as any).username ?? '').trim();
        if (!uuid || !username) continue;
        byUuid.set(uuid, { uuid, username, ranks: Array.isArray((it as any).ranks) ? (it as any).ranks : [] });
      }
      this.options = Array.from(byUuid.values());
    })
  }

  protected readonly onkeyup = onkeyup;
}
